import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild
} from '@angular/core';
import type { DealFindInterface } from '@zaoblako/shared/modules/business/dto/deal/deal-find.dto';
import { DealService } from '@zaoblako/web/core/services/deal/deal.service';
import { StatusLabelComponent } from '@zaoblako/web/shared/components/status-label/status-label.component';
import { AutoCompleteComponent } from '@zaoblako/web/shared/dumbs/autoComplete/auto-complete/auto-complete.component';
import { HighlightMatchTextHelper } from '@zaoblako/web/shared/helpers/highlight-match-text.helper';
import { SafeHtmlPipe } from '@zaoblako/web/shared/pipes/safe-html.pipe';
import { TruncatePipe } from '@zaoblako/web/shared/pipes/truncate.pipe';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'crm-deal-auto-complete',
  standalone: true,
  imports: [CommonModule, AutoCompleteComponent, StatusLabelComponent, TruncatePipe, TooltipModule, SafeHtmlPipe],
  templateUrl: './deal-auto-complete.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DealAutoCompleteComponent {
  @ViewChild('dealAutoComplete', { static: true }) public dealAutoComplete: AutoCompleteComponent;

  @Input() public selectedDeal: DealFindInterface;
  @Output() public selectedDealChange = new EventEmitter<DealFindInterface>();

  @Input() public deals: DealFindInterface[] = [];
  @Input() public isError = false;

  @Input() public class: string;
  @Input() public styleClass: string | string[] | Set<string> | { [klass: string]: any };
  @Input() public inputStyle: any;
  @Input() public inputStyleClass: string;
  @Input() public placeholder: string;
  @Input() public disabled = false;
  @Input() public appendTo: string;
  @Input() public panelStyleClass = 'crm-deal-autocomplete-panel';
  @Input() public scrollHeight = '280px';
  @Input() public showClear = false;
  @Input() public loading = false;

  @Input() public customSearch = false;
  @Output() public dealSearch = new EventEmitter<string>();

  public constructor(
    private readonly dealService: DealService,
    private readonly cdRef: ChangeDetectorRef
  ) {}

  public toDeal(deal: any): DealFindInterface {
    return deal as DealFindInterface;
  }

  public searchDeal(name: string) {
    this.dealService
      .search({
        search: name,
        limit: 50,
        offset: 0
      })
      .subscribe((deals) => {
        this.deals = deals.items;
        this.cdRef.markForCheck();
      });
  }

  public highlightMatchText(text: string): string {
    return HighlightMatchTextHelper.highlightMatchText(text, this.dealAutoComplete?.autoComplete?.inputValue());
  }
}
